<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    isEditing: Boolean,
    stopPropagation: {
        type: Boolean,
        default: true,
    },
    editButtonPosition: {
        type: String,
        default: 'top-right',
    },
});

const emit = defineEmits(['toggle']);

const toggle = (event) => {
    if (props.stopPropagation) {
        event.stopPropagation();
    }
    emit('toggle');
};

const positionClasses = {
    'top-right': '-top-2 -right-2',
    'top-left': '-top-2 -left-2',
    'bottom-right': '-bottom-2 -right-2',
    'bottom-left': '-bottom-2 -left-2',
    'inside-right': 'right-0',
    'inside-left': 'left-0',
};

</script>

<template>
    <div
        :class="[
            'absolute bg-gray-200 hover:bg-gray-300 rounded-md cursor-pointer text-gray-500 p-1 z-10',
            positionClasses[editButtonPosition]
        ]"
        @click="toggle"
    >
        <icon :name="isEditing ? 'editing' : 'edit'" size="14" />
    </div>
</template>
